<template>
  <core-view fill-height class="view">
    <template>
      <div v-if="!loading" class="center">
        <v-form ref="form">
          <div class="linha">
            <btn-auto-complete
              label="Operador"
              :redirect="rotaFiltros[0]"
              :dados="autocomplete.operador"
              v-model="formulario.laaidoperador"
              :returnObject="false"
              item-label="pesnome"
              item-value="pesidpessoa"
              :readonly="true"
              :rules="rules.laaidoperador"
            />
          </div>
          <div class="linha">
            <btn-auto-complete
              label="Propriedade"
              icon="mdi-chevron-down"
              :dados="autocomplete.propriedade"
              v-model="formulario.laaidpropriedade"
              :returnObject="false"
              item-label="pronome"
              item-value="proidpropriedade"
              :readonly="true"
              :rules="rules.laaidpropriedade"
            />
          </div>
          <div class="linha">
            <v-select
              outlined
              label="Talhão"
              :items="autocomplete.talhao"
              icon="mdi-chevron-down"
              v-model="formulario.laaidtalhao"
              class="select"
              :returnObject="false"
              :item-text="$$_talhaoFormatado"
              item-value="talidtalhao"
              :readonly="readonly"
              ref="talhao"
              clearable
            />
          </div>
          <div class="linha">
            <v-select
              outlined
              label="Atividade"
              :items="autocomplete.atividade"
              class="select"
              icon="mdi-chevron-down"
              v-model="formulario.laaidatividade"
              :returnObject="false"
              :item-text="$$_atividadeFormatada"
              item-value="ataidatividadeabastecimento"
              :readonly="readonly"
              :rules="rules.laaidatividade"
            >
            </v-select>
          </div>
          <div class="linha">
            <core-date-time-picker-field
              hide-details
              form
              :readonly="readonly"
              v-model="formulario.laadatainicio"
              :label="['Data inicio', 'Hora']"
              :rules="rules.laadatainicio"
            />
          </div>
          <div class="linha">
            <core-date-time-picker-field
              hide-details
              form
              :readonly="readonly"
              v-model="formulario.laadatatermino"
              :clearable="true"
              ref="datatermino"
              :label="['Data termino', 'Hora']"
              :rules="rules.laadatatermino"
              :sem-valor="semvalor"
              @limpatermino="$_terminoResetaValor"
            />
          </div>
          <div class="linha">
            <v-textarea
              label="Observação"
              outlined
              :readonly="readonly"
              hide-details="auto"
              rows="3"
              counter="150"
              :auto-grow="false"
              no-resize
              :style="{ 'background-color': 'white' }"
              class="text-area"
              :rules="rules.laaobservacao"
              v-model="formulario.laaobservacao"
            >
            </v-textarea>
          </div>

          <br/>

          <div class="divinferior">
            <v-btn
              v-if="!readonly"
              height="45"
              class="green botaoinferior"
              @click="$_cancelar"
            >
              Cancelar
            </v-btn>
            <v-btn
              v-if="!readonly"
              height="45"
              class="green botaoinferior"
              @click="$_salvaDados"
            >
              Salvar
            </v-btn>
          </div>
        </v-form>
      </div>
    </template>
  </core-view>
</template>

<script>
import CoreView from '@/components/core/view/Index.vue';
import BtnAutoComplete from '@/components/core/btn-auto-complete/Index.vue';
import { ROUTE_APONTAMENTO, ROUTE_OPERADOR } from '@/constants/ROUTES';
import errorHandler from '@/utils/error-handler';
import db from '@/plugins/dexie';
import { LANCAMENTO_STORAGE } from '@/constants/STORAGE';
import { SetupWebSocket } from '@/utils/ws/websocket';

import CoreDateTimePickerField from '@/components/core/variant/date-time-picker-field variant/Index.vue';
import geraData from '@/utils/geradata';

import ScrollUp from '@/utils/scroll-up';

//
function getSessionStorageParse(key, defaultValue) {
  const retorno = sessionStorage.getItem(key) ?? defaultValue;
  try {
    return JSON.parse(retorno);
  } catch {
    return retorno;
  }
}
//
export default {
  name: 'APCadastro',
  components: {
    CoreView,
    BtnAutoComplete,
    CoreDateTimePickerField,
  },
  data() {
    return {
      rotaFiltros: [ROUTE_OPERADOR],
      loading: true,
      readonly: false,
      idatividade: null,
      autocomplete: {
        atividade: null,
        operador: null,
        propriedade: null,
      },
      formulario: {
        laaidatividade: '',
        laaidoperador: '',
        laaidpropriedade: '',
        laaidtalhao: '',
        laadatainicio: geraData(),
        laadatatermino: geraData(),
        laaobservacao: '',
        //
        laadatacriacao: geraData(),
        laaidusuario: getSessionStorageParse('user:useidnuvem', null),
        laadataatualizacao: geraData(),
        laaidnuvem: '',
        laadatanuvem: null,
      },
      rules: {
        laaidatividade: [(v) => !!v || 'Atividade não pode ser vazio'],
        laaidoperador: [(v) => !!v || 'Operador não pode ser vazio'],
        laaidpropriedade: [(v) => !!v || 'Propriedade não pode ser vazio'],
        // laaidtalhao: [v => !!v || 'Talhão não pode ser vazio'],
        laadatainicio: [
          (v) => !!v || 'Data de início não pode ser vazia',
          (v) => {
            const termino = this.formulario.laadatatermino;
            if (!termino || this.semvalor) return true; // termino vazio → não compara
            // eslint-disable-next-line no-restricted-globals
            if (isNaN(new Date(termino).getTime())) return true; // termino inválido → não compara
            return v < termino || 'Data de início não pode ser maior que a data de término';
          },
        ],
        laadatatermino: [
          (v) => {
            if (!v || this.semvalor) return true; // campo vazio → permite salvar
            // eslint-disable-next-line no-restricted-globals
            if (isNaN(new Date(v).getTime())) return 'Data de término inválida'; // guard Invalid Date
            return v > this.formulario.laadatainicio || 'Data de término não pode ser menor que a data de início';
          },
        ],
        laaobservacao: [(v) => v.length <= 150 || 'Observação acima do tamanho maximo'],
      },
      semvalor: false,
    };
  },

  computed: {
    $$_atividadeFormatada() {
      return (item) => `${item.atacodigo} - ${item.atadescricao}`;
    },
    $$_talhaoFormatado() {
      return (item) => `${item.talcodigo} - ${item.taldescricao}`;
    },
  },

  methods: {
    async  ScrollUp(e) {
      ScrollUp(e);
    },
    async $_salvaDados() {
      if (!this.$refs.form.validate()) {
        errorHandler('Formulário invalido.');
        return;
      }
      document.activeElement.blur();
      setTimeout(async () => {
        // const formFromStorage = await JSON.parse(sessionStorage.getItem(LANCAMENTO_STORAGE.formulario, this.formulario));
        const dadosParaSalvar = { ...this.formulario };
        // ✅ VALIDAÇÃO: nunca salvar Invalid Date no banco
        // eslint-disable-next-line no-restricted-globals
        const isValidDate = (val) => val && !isNaN(new Date(val).getTime());

        if (!isValidDate(dadosParaSalvar.laadatainicio)) {
          errorHandler('Data de início inválida. Por favor, preencha novamente.');
          return;
        }

        if (dadosParaSalvar.laadatatermino && !isValidDate(dadosParaSalvar.laadatatermino)) {
          // Corrige silenciosamente ou bloqueia — escolha a abordagem:
          // formFromStorage.laadatatermino = null; // opção A: limpa
          errorHandler('Data de término inválida.'); return; // opção B: bloqueia
        }
        if (this.idatividade) {
          // UPDATE
          db.lancamentoatividade.update(Number(this.idatividade), dadosParaSalvar);
        } else {
          // CREATE
          console.log('SAO');
          db.lancamentoatividade.add(dadosParaSalvar);
        }
        sessionStorage.removeItem(LANCAMENTO_STORAGE.formulario);

        this.$router.replace({
          ...this.$route,
          name: ROUTE_APONTAMENTO.name,
        });
      });
    },

    async $_setupAutoComplete() {
      this.autocomplete.atividade = await db.atividadeabastecimento.toArray()
        .then((data) => data.sort((a, b) => a.atacodigo - b.atacodigo));
      this.autocomplete.operador = await db.pessoa.toArray();
      this.autocomplete.propriedade = (await db.propriedade.toArray()).filter((item) => item.proidpessoa == null);
      this.autocomplete.talhao = (await db.talhao.toArray()).filter((item) => item.talcodigo != null);
      this.loading = false;
      // Foco Inicial
    },

    async $_storageToForm() {
      if (!sessionStorage.getItem(LANCAMENTO_STORAGE.formulario)) {
        setTimeout(() => {
          this.$_terminoResetaValor();
        }, 200);
      } else {
        const formFromStorage = JSON.parse(sessionStorage.getItem(LANCAMENTO_STORAGE.formulario, this.formulario));
        if (formFromStorage.laadatatermino) {
          this.formulario = { ...this.formulario, ...formFromStorage };
        } else {
          this.formulario = { ...this.formulario, ...formFromStorage, laadatatermino: geraData() };
          if (!formFromStorage.laadatatermino) {
            setTimeout(() => {
              this.$_terminoResetaValor();
            }, 200);
          }
        }
      }
    },

    async $_formToStorage() {
      if (this.readonly) {
        return;
      }
      setTimeout(() => {
        if (this.$$_terminoTemValor()) {
          sessionStorage.setItem(LANCAMENTO_STORAGE.formulario, JSON.stringify(
            { ...this.formulario },
          ));
          this.semvalor = false;
        } else {
          sessionStorage.setItem(LANCAMENTO_STORAGE.formulario, JSON.stringify(
            { ...this.formulario, laadatatermino: null },
          ));
          this.semvalor = true;
        }
      });
    },

    async $_cancelar() {
      // ESTA SEM DIALOG POR ENQUANTO
      sessionStorage.removeItem(LANCAMENTO_STORAGE.formulario);
      this.$router.replace({
        ...this.$route,
        name: ROUTE_APONTAMENTO.name,
      });
    },

    // $_atividadeSearch(item, queryText) {
    //   if (!queryText) {
    //     return true;
    //   }

    //   const upperQuery = queryText.toUpperCase();
    //   const descricaoMatch = item.atadescricao && item.atadescricao.toUpperCase().includes(upperQuery);
    //   const codigoMatch = item.atacodigo && item.atacodigo.toString().toUpperCase().includes(upperQuery);

    //   return descricaoMatch || codigoMatch;
    // },

    async $_setupFields(id, readonly, replicado) {
      this.readonly = !!readonly;
      const formFromDexie = await db.lancamentoatividade.where({
        id: Number(id),
      }).first();
      if (replicado) {
        sessionStorage.removeItem(LANCAMENTO_STORAGE.replicado);
        sessionStorage.removeItem(LANCAMENTO_STORAGE.idlancamento);
        this.idatividade = null;
        const newForm = {
          laaidatividade: formFromDexie.laaidatividade,
          laaidoperador: formFromDexie.laaidoperador,
          laaidpropriedade: formFromDexie.laaidpropriedade,
          laaidtalhao: formFromDexie.laaidtalhao,
          laaobservacao: formFromDexie.laaobservacao,
        };
        this.formulario = { ...this.formulario, ...newForm };
        console.log(this.formulario, 'this.formulario');
        setTimeout(() => {
          this.$_terminoResetaValor();
        }, 200);
        return;
      }
      if (formFromDexie.laadatatermino) {
        this.formulario = { ...this.formulario, ...formFromDexie };
      } else {
        this.formulario = { ...this.formulario, ...formFromDexie, laadatatermino: geraData() };
        if (!formFromDexie.laadatatermino) {
          setTimeout(() => {
            this.$_terminoResetaValor();
          }, 200);
        }
      }
      this.formulario.laadataatualizacao = geraData();
      if (readonly) {
        Object.keys(this.rules).forEach((key) => {
          this.rules[key] = [() => true];
        });
      }
    },

    async $_terminoResetaValor() {
      if (this.$$_terminoTemValor()) {
        // Mesmo depois do clique terminoTemValor ainda está voltando true;
        await this.$$_terminoTemValor().firstElementChild.click();
        this.formulario.laadatatermino = null;
        this.semvalor = true;
        this.$nextTick(() => {
          //
          this.$_formToStorage();
        });
      } else {
        this.semvalor = false;
      }
    },

    $$_terminoTemValor() {
      const input = this.$refs.datatermino?.$el;
      const clearButton = input?.querySelector('.v-input__icon.v-input__icon--clear');
      console.log(!!clearButton);
      return clearButton;
    },
  },
  watch: {
    formulario: {
      deep: true,
      handler() {
        this.$_formToStorage();
      },
    },
  },
  created() {
    this.$_setupAutoComplete();
    this.idatividade = sessionStorage.getItem(LANCAMENTO_STORAGE.idlancamento);
    const replicado = sessionStorage.getItem(LANCAMENTO_STORAGE.replicado);
    const readonly = sessionStorage.getItem(LANCAMENTO_STORAGE.readonly);
    if (this.idatividade) {
      this.$_setupFields(this.idatividade, readonly, replicado);
      return;
    }
    this.$_storageToForm();
    SetupWebSocket();
  },
};
</script>

<style scoped>
.center {
  text-align: center;
  width: 100%;
}
.linha {
  display: flex;
  justify-content: space-around;
}
.divinferior {
  display: flex;
  justify-content: space-between;
  width: 100%;
  bottom: 5px;
  right: 0%;
}

.botaoinferior {
  color: white;
}

.input-data {
  width: 110%;
}

.view {
  max-width: 450px;
}

.text-area {
  border: 1px solid #bbb;
  resize: none !important;
  white-space: normal;
}

:deep(.v-select:not(.v-autocomplete) .v-input__slot) {
  background-color: white !important;
}
</style>
